import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "waiting-time" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "WAITING TIME", -1)
const _hoisted_3 = { class: "update" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "notice" }, [
  /*#__PURE__*/_createElementVNode("p", null, "※当日のエリア毎の待ち時間をご案内いたします"),
  /*#__PURE__*/_createElementVNode("p", null, "※最新時間が更新されない場合はアプリを立ち上げ直ししてください")
], -1)
const _hoisted_5 = { class: "list-title" }
const _hoisted_6 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, "Updated " + _toDisplayString(_ctx.updatedTime?.time), 1),
    _hoisted_4,
    _createElementVNode("table", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.waitingTime, (item) => {
        return (_openBlock(), _createElementBlock("tr", null, [
          _createElementVNode("td", _hoisted_5, _toDisplayString(item?.title), 1),
          _createElementVNode("td", _hoisted_6, _toDisplayString(item?.time) + " min", 1)
        ]))
      }), 256))
    ])
  ]))
}